"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/ChatOnboarding/Steps/ResultStep/TrackersSetupTrackerRow";

import { cn } from "utils";
import type { TrackersSetupTrackerItem } from "./types";

const I18n = I18nUtil.createScoped(Translations);

interface TrackersSetupTrackerRowProps {
  item: TrackersSetupTrackerItem;
  index: number;
  className?: string;
}

export const TrackersSetupTrackerRow: React.FC<
  TrackersSetupTrackerRowProps
> = ({ item, index, className }) => (
  <div
    className={cn("flex flex-col gap-2 px-5 py-[18px]", className)}
    data-testid={`trackers-setup-tracker-row-${index}-view`}
  >
    <div className="flex items-center justify-between gap-2">
      <p className="title_l text-content_primary">{item.title}</p>
      {item.status === "active" ? (
        <div
          className="flex items-center gap-[5px] rounded-full px-[9px] py-[3px]"
          data-testid={`trackers-setup-tracker-status-${index}`}
        >
          <span
            className="size-1.5 shrink-0 rounded-full bg-content_accent1_primary"
            aria-hidden
          />
          <span className="body_medium_xs text-content_primary">
            {I18n.t("Active")}
          </span>
        </div>
      ) : null}
    </div>
    <p className="body_s text-content_secondary">{item.description}</p>
  </div>
);
